import React from 'react';
import DriversTable from './DriversTable';

export default function RejectedDrivers() {
  return <DriversTable title="Rejected" orderByChild="status" equalTo="rejected" />;
}
